"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@xstate/react");
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _providerComponents = require("@kyruus/provider-components");
var _utils = require("../../lib/utils");
var _xstate2 = require("../../lib/constants/xstate");
var _styles = require("./styles");
var _ErrorPageSharedContent = _interopRequireDefault(require("./ErrorPageSharedContent"));
const ErrorPageCancelDisabled = _ref => {
  let {
    service
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  const {
    appointment: {
      patientRelationship = '',
      patientPurpose = '',
      startDateTime = ''
    },
    locationId,
    locations,
    provider = {}
  } = state.context;

  // Sidebar adapter
  const appointmentQuery = {
    patientRel: patientRelationship,
    purpose: {
      name: patientPurpose
    }
  };
  const selectedAppointment = {
    start_datetime: startDateTime,
    location_id: locationId
  };
  const providerPhone = (0, _utils.hasProvider)(provider) && (0, _providerComponents.getProviderContactPhone)(provider);
  let bannerText = '';
  if ((0, _utils.subStateMatchHelper)(_xstate2.states.cancelDisabledPage, state)) {
    if (providerPhone) {
      bannerText = 'cancelationDisabledBanner';
    } else {
      bannerText = 'cancelationDisabledBannerNoProvider';
    }
  } else if ((0, _utils.subStateMatchHelper)(_xstate2.states.cancelExpiredPage, state)) {
    if (providerPhone) {
      bannerText = 'cancelationExpiredBanner';
    } else {
      bannerText = 'cancelationExpiredBannerNoProvider';
    }
  } else {
    bannerText = 'cancelationDisabledBannerNoProvider';
  }
  return /*#__PURE__*/_react.default.createElement(_styles.CancelDisabledWrapper, {
    "data-testid": "CancelDisabled"
  }, /*#__PURE__*/_react.default.createElement(_ErrorPageSharedContent.default, {
    errorHeadingText: 'cancelationDisabledHeading',
    bannerText: bannerText,
    phone: providerPhone || ''
  }), (0, _utils.hasProvider)(provider) && /*#__PURE__*/_react.default.createElement(_styles.SideBarWrapper, null, /*#__PURE__*/_react.default.createElement(_providerComponents.ProviderSidebar, {
    provider: provider,
    locations: locations,
    appointmentQuery: appointmentQuery,
    selectedAppointment: selectedAppointment,
    showSchedulingHelpBanner: false
  })));
};
ErrorPageCancelDisabled.propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired
};
var _default = exports.default = ErrorPageCancelDisabled;
ErrorPageCancelDisabled.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorPageCancelDisabled",
  "props": {
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    }
  }
};